import React from 'react';
import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';

const SectionHeading = ({ children, className = '' }) => {
    const theme = useTheme();
    return (
        <h2
            className={`${css`
                font-size: 21px;
                line-height: 1;
                font-weight: bold;
                color: ${theme.colours.darkGray};
                padding-top: 32px;
                padding-bottom: 18px;
            `} ${className}`}
        >
            {children}
        </h2>
    );
};
export default SectionHeading;
